
<template>
  <AdminNavBar v-if="isAdminRoute" />
  <NavBar v-else />
  <router-view />
</template>

<script>
import NavBar from './components/NavBar.vue'
import AdminNavBar from './components/AdminNavBar.vue'

export default {
  name: 'App',
  components: { NavBar, AdminNavBar },
  computed: {
    isAdminRoute() {
      return this.$route.path.startsWith('/admin')
    }
  }
}
</script>

<style>
body {
  margin: 0;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  background-color: #f8f9fa;
}
</style>
